import axios from 'axios';


// --------------
import * as errors from './errors';
import * as types from './types';

// --------------
import { config } from '../../constants/config';



// ---------------
// FUNCTIONS ----

export const authHeader = () => {
    const token = localStorage.getItem('token');

    return {
        'Authorisation': token
    }
    
}




export const handleServerErrors = (dispatch, callback, e) => {

    let message = '';

    if (e.response && e.response.status === 401) {
        message = errors.INCORRECT_CREDENTIALS.description;
    } else {
        message = errors.CONNECTION_TO_API_NOT_WORKING.description
    }

    dispatch({ type: types.AUTH_ERROR, payload: message });
    callback(false, message, true);

}


export const runRegularUpload = async (route, formProps, dispatch, callback) => {

    try {

        // Pick up the groceries
        const response = await axios.post(route, formProps, { headers: authHeader(), onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(`Upload Progress: ${percentCompleted}%`);
          } });

        JSONResponseToConsole(`POST TO ${route} endpoint`, response);

        // Unpack the groceries
        const { success, payload } = response.data;

        callback(success, payload);
        
    } catch (e) {

        handleServerErrors(dispatch, callback, e);

    }

}




export const runRegular = async (route, formProps, dispatch, callback) => {

    try {

        // Pick up the groceries
        const response = await axios.post(route, formProps, { headers: authHeader() });

        JSONResponseToConsole(`POST TO ${route} endpoint`, response);

        // Unpack the groceries
        const { success, payload } = response.data;

        callback(success, payload);
        
    } catch (e) {

        handleServerErrors(dispatch, callback, e);

    }

}


export const runGetFile = async (route, urlToUse, dispatch, callback) => {

    try {

        // Pick up the groceries
        const response = await axios.get(`${route}/${urlToUse}`, { headers: { ...authHeader() }, responseType: 'arraybuffer' }); // previously blob

        JSONResponseToConsole(`GET TO ${route}/${urlToUse} endpoint`, response);
                
        const arrayBuffer = response.data;
        const uint8Array = new Uint8Array(arrayBuffer);
        let binary = '';

        for (let i = 0; i < uint8Array.length; i++) {
            binary += String.fromCharCode(uint8Array[i]);
        }
        const fileBase64 = btoa(binary);

        // Get the MIME type from the response headers
        const contentType = response.headers['content-type'] || 'application/octet-stream';
        const fileDataUrl = `data:${contentType};base64,${fileBase64}`;

        // Callback with the data URL
        callback(true, fileDataUrl);
        
    } catch (e) {

        handleServerErrors(dispatch, callback, e);

    }

}


export const executeActions = (All_Action_Payloads, callback) => async dispatch => {

    All_Action_Payloads.forEach(Individual_Action_Payload => {
        const { action, payload } = Individual_Action_Payload;
        dispatch({ type: action, payload: payload });
    });
    
    callback();

} 

export const JSONResponseToConsole = (label, json) => {

    if (config.TESTING_FUNCTIONS) {
        console.log(label, ' ', json);
    }
    
}


// --------------
// ACTION LIST

// None